module.exports = __webpack_public_path__ + "img/1.68dff9b7.png";